import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import ParentLayout from '../Layout';
import Navigation from '../../../dialogs_common/Navigation';
import Urls from '../Urls';
import Form from './Form';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../../hooks/useRouter';

export default function Layout(props) {
  const { history, match } = useRouter();
  const user = useUser();
  const event = useConnect('event.byId', {
    id: Number(match.params.eventId)
  });

  if (event.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      event={event}
      page="Student Size"
      title="How many students will the partner work with at one time?"
    >
      <Form
        user={user}
        event={event}
        navigation={(
          <Navigation v5={true} activeStep={4} steps={13}/>
        )}
        onPrevious={(newData) => history.push(Urls(event).STUDENT_AGE)}
        onNext={(newData) => history.push(Urls(event).TITLE)}
        onSkip={() => history.push(Urls(event).TITLE)}
        onExit={() => history.push(Urls(event).EVENT_EDIT)}
      />
    </ParentLayout>
  );
};
